export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src="https://storage.readdy-site.link/project_files/2836f450-9c16-4795-8079-772e594f98c3/61c8cedb-c449-4a38-866d-000c888efc53_compressed_1.webp"
                alt="다다손해사정"
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="mt-6 text-sm leading-relaxed text-background-300 max-w-md">
              고객의 문제를 정확하게 파악하고 효과적인 법률서비스를 제공합니다.
              관련 전문가와의 협업을 통한 최상의 솔루션을 제공하는 다다손해사정입니다.
            </p>
            <div className="mt-6 flex gap-2">
              {[
                { i: "ri-youtube-fill", h: "https://youtube.com/channel/UCenpa2i5gzClXmelYa0pizA?si=LKDV0AHLfgZpQeXg" },
                { i: "ri-instagram-line", h: "https://www.instagram.com/dada.sonsa/" },
                { i: "ri-quill-pen-fill", h: "https://blog.naver.com/sonsabosang" },
              ].map((x) => (
                <a
                  key={x.i}
                  href={x.h}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 text-background-100 hover:text-background-50 transition cursor-pointer"
                >
                  <i className={x.i}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="font-heading font-bold text-background-50 text-lg mb-5">
              바로가기
            </div>
            <ul className="flex flex-col gap-3 text-sm text-background-300">
              {[
                { l: "회사소개", h: "#about" },
                { l: "업무영역", h: "#services" },
                { l: "업무절차", h: "#process" },
                { l: "성공사례", h: "#cases" },
                { l: "상담신청", h: "tel:010-2696-9689" },
              ].map((x) => (
                <li key={x.l}>
                  <a
                    href={x.h}
                    className="hover:text-primary-300 transition cursor-pointer"
                  >
                    {x.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="font-heading font-bold text-background-50 text-lg mb-5">
              오시는 길
            </div>
            <div className="text-sm text-background-300 leading-relaxed">
              경기도 고양시 덕양구 백양로 32-31 효원빌딩 506호
            </div>
            <div className="mt-4 rounded-md overflow-hidden border border-background-50/10">
              <iframe
                src="https://www.google.com/maps?q=%EA%B2%BD%EA%B8%B0%EB%8F%84%20%EA%B3%A0%EC%96%91%EC%8B%9C%20%EB%8D%95%EC%96%91%EA%B5%AC%20%EB%B0%B1%EC%96%91%EB%A1%9C%2032-31&output=embed"
                width="100%"
                height="160"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="border-0"
              ></iframe>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-background-400">
          <div className="flex flex-wrap gap-x-3 gap-y-1">
            <span>상호명 : 다다손해사정</span>
            <span className="text-background-500">|</span>
            <span>대표 : 이동언</span>
            <span className="text-background-500">|</span>
            <span>대표번호 : 031-972-9689</span>
            <span className="text-background-500">|</span>
            <span>이메일 : dcsnow@naver.com</span>
          </div>
          <div>© 2026 DADA CLAIM ADJUSTMENT. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}